import React, { useEffect, useState } from "react";
import { DataTable } from "../widgets";
import { formatNumber, Unit } from "../../helpers/unit";
import { useSelector } from "react-redux";

const LoadsTareSummaryTable = (props) => {
  const {
    data: { header, body, isTare },
  } = props;
  const settings = useSelector((state) => state.user.settings);
  const { weightShortName } = settings;
  const [totalCount, setTotalCount] = useState({});
  const unit = Unit.getInstance();

  useEffect(() => {
    const totalCounts = {};

    body.forEach((row) => {
      Object.keys(row).forEach((column) => {
        if (column !== "id" && typeof row[column] === "number") {
          if (!totalCounts[column]) {
            totalCounts[column] = 0;
          }
          totalCounts[column] += row[column];
        }
      });
    });

    setTotalCount(totalCounts);
  }, [body]);

  return (
    <>
      <div className="summary_loads_container asA">
        <div className="summary_count">
          {isTare ? "Total Tare Loads:" : "Total Loads:"}{" "}
          <span>
            {totalCount["load_count"]
              ? formatNumber(unit.toFixedOf(totalCount["load_count"], 2))
              : 0}
          </span>
        </div>
        <span className="summary_divder"></span>
        <div className="summary_count">
          {isTare ? "Total Tare Weight:" : "Total Weight:"}{" "}
          <span>
            {totalCount["tare_weight"]
              ? formatNumber(unit.toFixedOf(totalCount["tare_weight"], 2))
              : totalCount["tare_weight"]}
          </span>{" "}
          {weightShortName}
        </div>
      </div>
      <DataTable>
        <DataTable.Header>
          <DataTable.Row>
            {header.map((item) => (
              <DataTable.Cell key={item.key} width={item.width}>
                {item.label}
              </DataTable.Cell>
            ))}
          </DataTable.Row>
        </DataTable.Header>
        <DataTable.Body>
          {body.map((cellItem, index) => (
            <DataTable.Row key={index}>
              {header.map((item) => (
                <DataTable.Cell
                  key={item.key}
                  width={item.width}
                  style={
                    cellItem[item.key] === "Unknown" || !cellItem[item.key]
                      ? { color: "red" }
                      : {}
                  }
                >
                  {item.key === "tare_weight"
                    ? formatNumber(cellItem[item.key])
                    : cellItem[item.key]
                    ? cellItem[item.key]
                    : "Unknown"}
                </DataTable.Cell>
              ))}
            </DataTable.Row>
          ))}
        </DataTable.Body>
      </DataTable>
    </>
  );
};

export default LoadsTareSummaryTable;